import BusinessProcessKpi from './BusinessProcessKpi';
import store from '@/store';
/**
 * BusinessProcess Class.
 *
 * @module HealthThresholds
 **/
export default class HealthThresholds {
  /**
   * @constructor
   * @this {HealthThresholds}
   *
   * @param {Object} rawHealthThresholds - Health Thresholds.
   **/
  constructor({ _id, name, active, supervisorId, businessProcessId, kpis }) {
    Object.assign(this, ...arguments);
  }

  get businessProcessKpis() {
    const result = {};

    const stats = store.getters['STATS/getBusinessProcessesStats'].find(
      stats => stats.businessProcessId === this.businessProcessId
    );
    if (stats) {
      Object.entries(stats).forEach(([id, data]) => {
        if (!data.hasOwnProperty('value')) {
          return;
        }

        const thresholds = this.kpis.find(kpi => kpi.id === id) || {
          danger: null,
          warning: null
        };

        result[id] = new BusinessProcessKpi({
          id,
          thresholds,
          businessProcessId: this.businessProcessId,
          ...data
        });
      });
    }

    return result;
  }
}
